<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >

      

        <v-dialog
          v-model="dialog"
          width="1000"
          hegiht="auto"
          persistent
        >
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md4
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              Create new course
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
        
            <FormCourse
              :CourseTypeList="courseTypeList"
              :Item="item"
              :Field="inputFields"
              :Value="valueObj"
              @emitted="getBackData"
              @closed="closeModal"
              />
          </v-card>
        </v-dialog>
        <material-card
          color="green"
          title="Course List"
          text="The courses those are being provided by BacBon"
        >

          <v-data-table
            :headers="headers"
            :items="courseList"
            
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td> <router-link  :to="'/course-details/'+item.id">{{ item.name }}</router-link></td>
              <td>{{ item.status }}</td>
              <td>
                
              <v-btn color="success" fab small dark round @click="enableEdit(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
                
                </td>
            </template>
          </v-data-table>

        <v-dialog
          v-model="dialogEdit"
          width="1000"
          hegiht="auto"
          persistent
        >
          <template v-slot:activator="{ on }">
            
          </template>

          <v-card>
        
            <FormCourseEdit
              :CourseTypeList="courseTypeList"
              :Item="item"
              :Field="inputFields"
              :Value="course"
              @emitted="EditCourse"
              @closed="closeModal"
              />
          </v-card>
        </v-dialog>
        </material-card>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div> {{ errorMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import FormCourse from '@/views/FormCourse'
import FormCourseEdit from '@/views/FormCourseEdit'
export default {
  components: {
    FormCourse,
    FormCourseEdit
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('courses', ['courseList', 'courseTypeList']),
  },
  mounted () {
    this.getcourselist()
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
    course: {},
    headers: [
      {
        sortable: true,
        text: 'Course',
        value: 'name'
      },
      {
        sortable: true,
        text: 'Status',
        value: 'status'
      },
      {
        sortable: false,
        text: 'Action',
        value: 'action'
      },
    ],
      dialog: false,
      dialogEdit: false,
      errorMessage: '',
      item: {
        'title': 'Create new',
        'subTitle': 'This is the subtitle',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      valueObj: { },
      inputFields: [
        {
          label: 'Course Name',
          type: 'text',
          isEnable: true,
          name: 'name',
          formName: 'Course name',
          nameRules: [
            v => !!v || 'Course name is required',
            v => (v && v.length <= 190) || 'Course name must be less than 190 characters',
            v => /^[\w. ]+$/.test(v) || 'Special character not allowed'
          ]
        },
        {
          label: 'Course Name (বাংলা)',
          type: 'text',
          isEnable: true,
          name: 'name_bn',
          formName: 'Course name',
          nameRules: [
            v => !!v || 'Course name Bangla is required',
            v => (v && v.length <= 190) || 'Course name bangla must be less than 190 characters'
          ]
        },
        {
          label: 'Price',
          type: 'number',
          isEnable: true,
          name: 'price',
          formName: 'price',
          nameRules: [
            v => !!v || 'Price is required',
          ]
        },
        {
          label: 'Status',
          type: 'text',
          isEnable: true,
          name: 'status',
          formName: 'Status',
          nameRules: [
            v => !!v || 'Status is required',
            v => (v && v.length <= 30) || 'Status must be less than 30 characters'
          ]
        }
       
      ]
    }
  },
  created () {
    this.getCourseTypeList()
  },
  methods: {
    ...mapActions("courses", ["fetchData","CreateCourse", "getcourselist", "getCourseTypeList", "updateCourse"]),
    enableEdit (item) {
      this.course = item
      this.dialogEdit = true
    },
    EditCourse (data) {
      this.updateCourse(data).then((response) => {
        if (response.status == 'OK') {
          this.getcourselist()
          this.dialogEdit = false
          this.color = 'success'
          this.errorMessage = response.messages
          this.snack('top')
        } else {
          this.dialogEdit = false
          this.color = 'warning'
          this.errorMessage = response.messages
          this.snack('top')
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getBackData (data) {
      this.CreateCourse(data).then((response) => {
        console.log(response)
        if (response.status == 'OK') {
          this.getcourselist()
          this.dialog = false
          this.color = 'success'
          this.errorMessage = response.messages
          this.snack('top')
        } else {
          this.dialog = false
          this.color = 'warning'
          this.errorMessage = response.messages
          this.snack('top')
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    
    closeModal () {
      this.dialog = false
      this.dialogEdit = false
    },
    
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }

      this.color = this.colors[Math.floor(Math.random() * this.colors.length)]

      this.snackbar = true
    }
  }
}
</script>
